<template>
  <form>
    <b-alert
      v-if="findError('shares')"
      show
      variant="danger"
      class="mt-4">
      {{ findError('shares') }}
    </b-alert>
    <data-table
      :columns="sharesColumns"
      :value="value.shares"
      empty-message="Nessuna condivisione trovata"
      row-class="row align-items-center pb-0"
      alert-class="mt-4"
    />
    <div class="text-right" v-if="!disabled">
      <b-button variant="success" @click.prevent="addShare">
        <i class="fa fa-fw fa-plus"></i> Aggiungi
      </b-button>
    </div>
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';

export default {
  mixins: [ EntityEditorMixin ],

  created() {
    this.sharesColumns = [
      {
        type: 'component',
        component: 'user-form-field',
        //class: () => this.disabled ? 'col-12' : 'col-11',
        class: () => this.disabled ? 'col-md-12 mb-2' : 'col-md-12 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'user', label: 'Utente' }),
        events: this.columnEvents({ prop: 'shares', key: 'user' }),
      },
      {
        class: 'col-md-12',
        type: 'actions',
        show: () => !this.disabled,
        actions: (item, index) => [
          {
            label: 'Rimuovi condivisione',
            //icon: 'times',
            buttonClass: 'bg-danger w-100 text-center mb-2',
            exec: () => this.removeShare(index)
          }
        ]
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permLoad', label: 'Visualizza analisi principale' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permLoad' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permUpdate', label: 'Modifica analisi principale' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permUpdate' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permReadMessages', label: 'Leggi messaggi' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permReadMessages' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permSendMessages', label: 'Invia messaggi' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permSendMessages' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permReceiveMessages', label: 'Ricevi notifiche messaggi' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permReceiveMessages' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permViewFiles', label: 'Visualizza file' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permViewFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permViewFilesWithNoTags', label: 'Visualizza file SENZA TAG' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permViewFilesWithNoTags' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permUploadFiles', label: 'Carica file' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permUploadFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permRenameFiles', label: 'Rinomina file' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permRenameFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permAddFileTags', label: 'Aggiungi tag a file' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permAddFileTags' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permRemoveFileTags', label: 'Rimuovi tag da file' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permRemoveFileTags' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permDeleteFiles', label: 'Elimina file' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permDeleteFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permReceiveFiles', label: 'Ricevi notifiche file' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permReceiveFiles' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permLoadXbrlAnalysis', label: 'Visualizza analisi bilancio' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permLoadXbrlAnalysis' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permUpdateXbrlAnalysis', label: 'Modifica analisi bilancio' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permUpdateXbrlAnalysis' }),
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permLoadCrAnalysis', label: 'Visualizza analisi CR' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permLoadCrAnalysis' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permUpdateCrAnalysis', label: 'Modifica analisi CR' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permUpdateCrAnalysis' }),
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-md-6 mb-0' : 'col-md-5 mb-0 offset-md-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permLoadCrifAnalysis', label: 'Visualizza analisi CRIF' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permLoadCrifAnalysis' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'shares', key: 'permUpdateCrifAnalysis', label: 'Modifica analisi CRIF' }, { inline: true }),
        events: this.columnEvents({ prop: 'shares', key: 'permUpdateCrifAnalysis' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'tag-form-field',
        //class: () => this.disabled ? 'col-12' : 'col-11',
        class: 'col-md-12',
        props: (item, index) => ({
          label: 'Tag permessi',
          value: item.tags.map(x => x.tag),
          dropdown: false,
          multiple: true,
          disabled: this.disabled,
          parameters: {
            nwi: true,
            workgroupIds: this.value.workgroup ? [this.value.workgroup.id] : null
          },
          error: this.findError('shares[' + index + '].tags')
        }),
        events: (item, index) => ({
          input: (v) => {
            this.tagsSelected(item, index, v);
          }
        })
      },

      {
        type: 'component',
        component: 'div',
        show: (item, index) => (index !== this.value.shares.length - 1),
        class: 'col content-separator mx-0 border-bottom-0',
      },
    ];
  },

  methods: {
    addShare() {
      const newValue = {
        user: null,
        permLoad: true,
        permUpdate: false,
        permReadMessages: true,
        permSendMessages: true,
        permReceiveMessages: true,
        permViewFiles: true,
        permViewFilesWithNoTags: false,
        permUploadFiles: true,
        permRenameFiles: true,
        permAddFileTags: true,
        permRemoveFileTags: false,
        permDeleteFiles: false,
        permReceiveFiles: true,
        permLoadXbrlAnalysis: true,
        permUpdateXbrlAnalysis: false,
        permLoadCrAnalysis: true,
        permUpdateCrAnalysis: false,
        permLoadCrifAnalysis: true,
        permUpdateCrifAnalysis: false,
        tags: [],
      };
      const shares = [ ...this.value.shares, newValue ];
      this.propertyChanged('shares', shares);
    },

    removeShare(index) {
      if (!confirm('Sei sicuro di voler rimuovere questa condivisione?')) {
        return;
      }

      const shares = [ ...this.value.shares ];
      shares.splice(index, 1);
      this.propertyChanged('shares', shares);
    },

    tagsSelected(item, index, tags) {
      const oldTags = sortBy(item.tags.map(t => t.tag.id));
      const newTags = sortBy(tags.map(t => t.id));

      if (!isEqual(oldTags, newTags)) {
        const arr = [ ...this.value.shares ];
        arr[index] = { ...item };
        arr[index].tags = tags.map(t => ({ user: item.user, tag: t }));
        this.propertyChanged('shares', arr);
      }
    },
  }
};
</script>
